// extracted by mini-css-extract-plugin
export default {"title":"Hiring_title__VM14a","container":"Hiring_container__1zXo0","blogDetail_container":"Hiring_blogDetail_container__qAKOE","btn":"Hiring_btn__q5Qq4"};